import type { KeyboardEvent, ReactElement } from 'react';

import { useTheme } from '@emotion/react';

import * as styles from './dropdown-list.styles';

type Props = {
  children: ReactElement | ReactElement[];
  onClick?: () => void;
  active?: boolean;
};

export const DropdownListItem = ({ children, onClick, active = false }: Props) => {
  const theme = useTheme();

  const handleKeyDown = (event: KeyboardEvent<HTMLLIElement>) => {
    if ((event.key === 'Enter' || event.key === ' ') && onClick) {
      onClick();
    }
  };

  return (
    <li
      css={[styles.item, active && styles.activeItem(theme), onClick && styles.clickable(theme)]}
      data-testid="dropdown-list-item"
      role={onClick ? 'button' : undefined}
      tabIndex={-1}
      onClick={onClick}
      onKeyDown={handleKeyDown}>
      {children}
    </li>
  );
};
